//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import { mapState } from 'vuex'
    import ImageSrcsetMixin from '~/mixins/ImageSrcsetMixin';
    import userChecks from '~/mixins/userChecks';
    import { formatDate, convertDuration } from '@/helpers/filters.js'
    export default {
        mixins: [ImageSrcsetMixin, userChecks],
        async fetch() {
          this.$store.commit('mxmStore/clearStream');

          const resource = await this.$store.dispatch('resourcesStore/getResource', {
            slug: this.$route.params.slug,
            query: this.queries.video,
            checkAccess: this.$auth.loggedIn
        });

          const resourceId = resource.id;

          if (this.$auth.loggedIn && resource.product === 'paid' && resource.status === 'published') {
            await this.$store.dispatch('resourcesStore/checkResourceAccess', {
              id: resourceId,
              type: this.queries.video.content
          });
        } else if (resource.product === 'free') {
            this.$store.commit('resourcesStore/setAccess', {
              access: true,
              subscription: [],
              type: 'video'
          });
        }

        await this.$store.dispatch('bannerStore/getBanner', 'resource');
    },
    beforeRouteEnter(to, from, next) {
        if (to.query.phone && to.query.phone == 'succes') {
            next(vm => {
                var phone_stream_id = vm.getCookie('phone_stream_id');
                if (phone_stream_id) {
                    var notificationObj = {
                        type: 'succes',
                        message: 'Je bent verbonden met Pay.NL. Je kunt al onze seksfilms en tv shows bekijken zolang je verbinding hebt!',
                    };
                    vm.$store.commit('notificationStore/setNotification', notificationObj, { root: true });
                    vm.$store.commit('resourcesStore/setAccess', {
                        access: true,
                        subscription: [{
                            subscription_id: 3,
                            subscription_detail_id: 8
                        }],
                        type: 'video'
                    });
                }
            })
        } else if (to.query.paywall && to.query.paywall == 'active') {
            next(vm => {
                vm.$store.commit('paywallStore/setView', 'active')
                // vm.checkPaywall();
            })
        } else {
            next(vm => {
                var phone_stream_id = vm.getCookie('phone_stream_id');
                if (phone_stream_id) {
                    vm.$store.commit('resourcesStore/setAccess', {
                        access: true,
                        is_free: false,
                        subscription: [{
                            subscription_id: 3,
                            subscription_detail_id: 8
                        }],
                        type: 'video'
                    });
                }
            });
        }
    },
    data() { 
        return {
            favorite: false,
            kind: false,
            read: {
              text: 'Lees meer',
              active: false  
          } 
      }
  },
  head() {
    return {
        title: this.video.title + ' | ' + process.env.APP_TITLE,
        meta: [
            { hid: 'og:url', name: 'og:url', content: process.env.FE_URL + '/seksfilms/' + this.video.slug},
            { hid: 'og:title', name: 'og:title', content: this.video.title},
            { hid: 'og:description', name: 'og:description', content: this.video.excerpt},
            { hid: 'title', name: 'title', content: this.video.title},
            { hid: 'description', name: 'description', content: this.video.excerpt},
            { hid: 'og:type', name: 'og:type', content: 'video.movie'},
            { hid: 'og:image', name: 'og:image', content: this.video.seoThumb},
            ]
    }
},
components: {
    breadcrumbs: () => import('~/components/breadcrumbs'),
    readmore: () => import('~/components/content/video/readmore_video'),
    dummy: () => import('~/components/content/dummy/detailed_dummy.vue'),
    videoplayer: () => import('~/components/content/video/videoplayer'),
    maxXsPlayer: () => import('~/components/maxxXsPlayer'),
    gallery: () => import('~/components/content/video/gallery_video'),
    videoCollection: () => import('~/components/content/video/video_collection'),
    banner: () => import('~/components/banner.vue'),
    related: () => import('~/components/content/video/related'),
    Paywall: () => import('~/components/payment/module.vue')
},
computed: {
    ...mapState({
        queries: ({ resourcesStore: {queries} }) => queries,
        access: ({ resourcesStore: {access} }) => access,
        video: ({ resourcesStore: {video} }) => video,
        loading: ({ resourcesStore: {loading} }) => loading,
        playerOptions: ({ mxmStore: {playerOptions} }) => playerOptions,
        stream: ({ mxmStore: {stream} }) => stream,
        killStream: ({ mxmStore: {killStream} }) => killStream,
        playerState: ({ mxmStore: {playerState} }) => playerState,
        preroll: state => state.mxmStore.preroll,
        modal: ({ modalStore: {modal} }) => modal,
    }),
},
mounted() {
    this.checkFavorite();
    this.checkPaywall();
},
watch: {
    access: function() {
        this.$auth.fetchUser();
        this.checkPaywall();
        console.log('access has changed so refresh the user');
    },
    preroll: function(newValue, oldValue) {
        if (newValue === 'shown') {
            this.loadFreeFilm(this.video.videos.data.free_film[0].id);
        }
    },
    stream: function() {
        if (this.stream.location == 'seksfilm' && this.stream.ITEM && this.stream.ITEM.LINKS) {
            if (this.video.images && this.video.images.data && this.video.images.data.thumb && this.video.images.data.thumb[0]) {
                var thumb = this.$config.cdn + this.video.images.data.thumb[0].path
            } else {
                var thumb = this.$config.cdn + this.$config.errorimg;
            }
            let playerOptions = {
                autoplay: true,
                poster: thumb
            }
            this.$store.commit('mxmStore/updatePlayerOptions', playerOptions);
            this.$store.commit('mxmStore/setPlayerType', this.stream.type);

            var phone_stream_id = this.getCookie('phone_stream_id');
            if (phone_stream_id) {
                // PPM access so we should check status with interval
                // Interval is handled by mxmStore
                var dataObj = {
                    action: 'update',
                    stream_id: phone_stream_id
                }; 
                this.$store.dispatch('mxmStore/startUpdateStream', dataObj);
            }
        }
    },
    killStream: function() {
        var phone_stream_id = this.getCookie('phone_stream_id');
        if (this.killStream == true && phone_stream_id) {
          this.doKillStream('phone');
      }
  },
  video: function() {
    this.checkPaywall();
    var phone_stream_id = this.getCookie('phone_stream_id');
    if (phone_stream_id) {
        this.$store.commit('resourcesStore/setAccess', {
            access: true,
            is_free: false,
            subscription: [{
                subscription_id: 3,
                subscription_detail_id: 8
            }],
            type: 'video'
        });
    }
}
},
beforeDestroy() {
    this.$store.dispatch('mxmStore/stopUpdateStream');
    this.$store.commit('resourcesStore/resetAccess')
},
methods: {
    formatDate,
    convertDuration,
    checkPaywall() {
        if (this.$route.params.slug != this.video.slug) {
            return;
        }
        if (!this.access.access && window.innerWidth < 992) {
            this.$store.commit('paywallStore/setView', 'active');
            this.$store.commit('paywallStore/setStep', 0);
        } else {
            this.$store.commit('paywallStore/setView', 'closed');
        }
    },
    checkFavorite() {
        if (this.$auth.loggedIn && this.hasFavoriteResource('video')) {
            var self = this;
            this.userFavoriteResources('video').forEach(function(favorite) { 
                if (self.video.id === favorite.id) {
                    self.favorite = true;
                }
            })
        }
    },
    readmore() {
        if (!this.$root.isMobile) {
            return this.$store.commit('modalStore/setModal', 'readmore');
        }
        this.read.active = !this.read.active;
        if (this.read.active) {
            this.read.text = 'Lees minder'
        } else {
            this.read.text = 'Lees meer'
        }
    },
    toggleFavo() {
        if (!this.$auth.loggedIn) {
            var notificationObj = [];
            notificationObj.type = 'info';
            notificationObj.message = 'Je kan alleen favorieten toevoegen als je bent ingelogd.';
            return this.$store.commit('notificationStore/setNotification', notificationObj, { root: true });
        }
        let data = {
            resource_id: this.video.id,
            subscribe: 1
        };
        if (this.$auth.loggedIn) {
            data.user_id = this.$auth.user.id;
        } else {
            var notificationObj = [];
            notificationObj.type = 'info';
            notificationObj.message = 'Je moet inloggen om seksfilms aan je favorieten toe te voegen.';
            this.$store.commit('notificationStore/setNotification', notificationObj, { root: true });
            return false;    
        }
        if (this.favorite) {
            data.subscribe = 0;
            this.favorite = false;
        } else {
            this.favorite = true;
        }
        this.$store.dispatch('accountStore/toggleFavorite', data);
    },
    loadTrailer(videoId) {
        this.$store.commit('mxmStore/clearStream');
        this.kind = false;
        var dataObj = [];
        dataObj.video_id = videoId;
        dataObj.resource_id = this.video.id;
        dataObj.product_type = 'free';
        dataObj.type = 'trailer';
        dataObj.location = 'seksfilm';
        this.$store.dispatch('mxmStore/getStream', dataObj)
    },
    async loadFreeFilm(videoId) {
        this.$store.commit('mxmStore/clearStream');
        this.kind = false;
        if (this.stream && this.stream.id && this.stream.type == 'free_film') {
            return this.$store.commit('mxmStore/setPlayerStatus', 'playing')
        }
        if (this.stream && this.stream.id && this.stream.type == 'trailer') {
            this.trailer = false;
        }
        if (this.video.product === 'free' && this.$auth.loggedIn && this.$auth.user.recurring && this.$auth.user.recurring.length === 0 && this.preroll != 'shown' ||
            this.video.product === 'free' && this.$auth.loggedIn && !this.$auth.user.recurring && this.preroll != 'shown' || 
            this.video.product === 'free' && !this.$auth.loggedIn && this.preroll != 'shown') {
            const preroll = await this.$store.dispatch('resourcesStore/getResources', this.queries.preroll);
        if (preroll && preroll.data.length) {
            const randomIndex = Math.floor(Math.random() * preroll.data.length);
            var dataObj = {
                video_id: preroll.data[randomIndex].videos.data.preroll[0].id,
                resource_id: preroll.data[randomIndex].id,
                href: preroll.data[randomIndex].extra.href,
                target: preroll.data[randomIndex].extra.target,
                type: 'preroll',
                location: 'sexfilm',
                product_type: 'free',
            };
            return this.$store.dispatch('mxmStore/getStream', dataObj);
        }
    } 

    var dataObj = {
        video_id: videoId,
        resource_id: this.video.id,
        type: 'free_film',
        location: 'seksfilm',
        product_type: 'free'
    };
    if (this.$store.state.auth.loggedIn) {
        dataObj.user_id = this.$store.state.auth.user.id;
    }
    this.$store.dispatch('mxmStore/getStream', dataObj);
},
loadPaidFilm(videoId) {
    this.$store.commit('mxmStore/clearStream');
    this.kind = false;
    if (this.stream && this.stream.id && this.stream.type == 'film') {
        return this.$store.commit('mxmStore/setPlayerStatus', 'playing')
    }
    var dataObj = {
        video_id: videoId,
        resource_id: this.video.id,
        type: 'film',
        location: 'seksfilm',
        product_type: 'paid'
    };
    if (this.$store.state.auth.loggedIn) {
        dataObj.user_id = this.$store.state.auth.user.id;
    }

    var phone_stream_id = this.getCookie('phone_stream_id');
    if (phone_stream_id) {
        dataObj.phone_stream_id = phone_stream_id;
        dataObj.subscription_id = 3;
        return this.$store.dispatch('mxmStore/getStream', dataObj)
    } else {
        dataObj.subscription_id = this.access.subscription.id ? this.access.subscription.id : 1;
        return this.$store.dispatch('mxmStore/getStream', dataObj)
    }
},
setStatus(status){
    this.$store.commit('mxmStore/setPlayerStatus', status)
},
doKillStream(type) {
  if (type == 'phone') {
    var notificationObj = [];
    notificationObj.type = 'warning';
    notificationObj.message = 'De verbinding is verbroken. Verder kijken? Bel dan opnieuw.';
    this.$store.commit('notificationStore/setNotification', notificationObj, { root: true });    
    document.cookie = "phone_stream_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    this.$store.commit('resourcesStore/setAccess', {
        access: false,
        is_free: false,
        subscription: []
    });
    this.$store.commit('mxmStore/clearStream');
}
},

}
}
